// removed by extract-text-webpack-plugin
module.exports = {"row_table":"components-tjcx-queryStudents-gyQueryStudents-show-row_table-3k2OU","col_left":"components-tjcx-queryStudents-gyQueryStudents-show-col_left-37QL0","col_right":"components-tjcx-queryStudents-gyQueryStudents-show-col_right-30bvP","blue":"components-tjcx-queryStudents-gyQueryStudents-show-blue-2vPkH"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/queryStudents/gyQueryStudents/show.css
// module id = 822
// module chunks = 0